export default {
  geolocation: {
    lat: '51.5072',
    lng: '0.1276',
    label: 'WC1 London',
  },
  price_rules: {
    grouping: ',',
    decimal: '.',
  },
}
